export default __webpack_public_path__ + "static/media/img1.71ad8113.PNG";